import { useEffect } from "react";
import {
  useDisconnect,
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from '@web3modal/ethers/react';
import { BrowserProvider } from 'ethers';

export const useHandleWalletConnection = () => {
  const { open } = useWeb3Modal();
  const { disconnect } = useDisconnect();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { walletProvider }: any = useWeb3ModalProvider();
  
  const onSignMessage = async () => {
    if (!walletProvider) return;

    try {
      const provider = new BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      const signature = await signer.signMessage('Hello Web3Modal Ethers');
      localStorage.setItem("signature", signature);
    } catch (error) {
      console.error("Failed to sign message:", error);
    }
  };

  useEffect(() => {
    const sign = localStorage.getItem("signature");
    console.log("sign:", sign)
    if (isConnected && !sign) {
      onSignMessage();
    }
  }, [isConnected, walletProvider]);

  return {
    open,
    disconnect,
    address,
    chainId,
    isConnected,
    walletProvider,
    onSignMessage,
  };
};
